/* DO NOT USE */


var animations4i = function(){
	var slideDown = function(elem, time) {
		if(time == null || time == "undefined"){
			time = 100;
		}
		// set initial styles for transition
		elem.style.maxHeight = "0";
		elem.style.opacity = "0";
		elem.style.overflow = "hidden";
		elem.style.transition = "all 0.6s ease";
		
		elem.classList.remove("hide");
		elem.style.display = "block";
		setTimeout(function () {
			elem.style.opacity = '1';
			elem.style.maxHeight = '2000px';
		}, time);
	},
	slideUp = function(elem, time) {
		if(time == null || time == "undefined"){
			time = 350;
		}
		elem.style.maxHeight = '0px';
		elem.style.opacity = '0';
		setTimeout(function () {
			elem.classList.add("hide");
			elem.style.display = "none";
		}, time);
	},
	fadeOut = function(el, duration) {
    		var s = el.style, step = 25/(duration || 300);
    		s.opacity = s.opacity || 1;
    		(function fade() { 
    			(s.opacity -= step) < 0 ? s.display = "none" : setTimeout(fade, 25); 
    		})();
	},
	fadeIn = function(el, duration, display) {
    		var s = el.style, step = 25/(duration || 300);
    		s.opacity = s.opacity || 0;
    		s.display = display || "block";
    		(function fade() { 
    			(s.opacity = parseFloat(s.opacity)+step) > 1 ? s.opacity = 1 : setTimeout(fade, 25); 
    		})();
	};
	
	return{
		slideDown: slideDown,
		slideUp: slideUp,
		fadeIn: fadeIn,
		fadeOut: fadeOut
	};
};